jQuery(document).ready(function($) {


    // reel-slider

  var $slider = $('.reels-slider');

  function isVideoPlaying(video) {
    return (
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > video.HAVE_CURRENT_DATA
    );
  }

  function resetAllVideos() {
    $('.reels-slider .slick-slide').each(function() {
      var $video = $(this).find('video');
      var videoEl = $video.get(0);

      if (videoEl) {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.muted = true; 
        $video.removeAttr('controls');
      }

      $(this).find('.reel-btn').show();
    });
  }

  function playCenterVideo() {
    var centerSlide = $('.reels-slider .slick-center');
    if (centerSlide.length === 0) {
        centerSlide = $('.reels-slider .slide-container').first();
      }
      centerSlide.find('.reel-btn').hide();
    
    var centerVideo = centerSlide.find('video').get(0);
    


    if (centerVideo && !isVideoPlaying(centerVideo)) {
      centerVideo.muted = true; 

      const playPromise = centerVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          console.log("Video autoplay prevented:", err);
        });
      }
    }
  }

  $slider.slick({
    centerMode: true,
    centerPadding: '0px',
    dots: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
draggable: true, swipe: true, touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20%'
        }
      }
    ]
  });

  // $('.custom-slick-arrows .prev').on('click', function() {
  //   $slider.slick('slickPrev');
  // });

  // $('.custom-slick-arrows .next').on('click', function() {
  //   $slider.slick('slickNext');
  // });

  setTimeout(function() {
      playCenterVideo();
  }, 500); 

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      resetAllVideos();
  });
  
  $slider.on('afterChange', function(){
    playCenterVideo();
    $('.reels-slider .slick-slide[aria-hidden="true"] *').blur();
  });

  $slider.on('click', '.slick-slide', function (e) {
    if ($(e.target).closest('.reel-btn').length) return; 
    var index = $(this).data('slick-index');
    $slider.slick('slickGoTo', index);
  });

  function isMobileDevice() {
    return window.innerWidth <= 767 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function enterFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.webkitEnterFullscreen) {
      element.webkitEnterFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  $slider.on('click', '.reel-btn', function(e) {
    e.stopPropagation();
    var $slide = $(this).closest('.slick-slide');
    
    if (!$slide.hasClass('slick-center')) {
      var index = $slide.data('slick-index');
      $slider.slick('slickGoTo', index);
      return; 
    }
    
    var $video = $slide.find('video');
    var videoEl = $video.get(0);

    if (videoEl) {
        videoEl.muted = false; 
        $video.attr('controls', true);
        $(this).hide();

        if (isMobileDevice()) {
          enterFullscreen(videoEl);
        }

        const playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.log("Video play prevented:", err);
          });
        }
    }
  });

  $(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function() {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && 
        !document.mozFullScreenElement && !document.msFullscreenElement) {
      var centerSlide = $('.reels-slider .slick-center');
      var centerVideo = centerSlide.find('video').get(0);
      if (centerVideo) {
        centerVideo.pause();
        centerVideo.muted = true;
        $(centerVideo).removeAttr('controls');
        centerSlide.find('.reel-btn').show();
      }
    }
  });



    $(document).on('click', '.js-ajax-add-to-cart', function(e) {
        e.preventDefault();

        var $clickedButton = $(this);
        var variantId = $clickedButton.data('variant-id');

        $clickedButton.prop('disabled', true).text('ADDING...');


        $.ajax({
            url: '/cart/add.js', 
            type: 'POST',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: 1
            },
            success: function(response) {
                console.log('Product added successfully:', response);
                alert('Item added to cart!');
            },
            error: function(xhr, status, error) {
                console.error('Cart insertion failed:', error);
                alert('Failed to add item. Please try again.');
            },
            complete: function() {
                $clickedButton.prop('disabled', false).text('ADD TO CART');
            }
        });
    });
});


// drawer
$(document).ready(function() {
  var $trigger = $('.burger-modal__body > div:first-child');
  var $gridPanel = $('.burger-modal__collections-grid');

  // Inject structural identifier classes and accessibility states safely
  $trigger
    .addClass('burger-modal__shop-all-trigger')
    .attr('role', 'button')
    .attr('aria-expanded', 'false');

  // Bind the interaction listener
  $trigger.on('click', function(e) {
    e.preventDefault();
    
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    var nextState = !isExpanded;

    // Slide toggle execution
    $gridPanel.slideToggle(350, function() {
      // Accessibility & state updates
      $trigger.toggleClass('is-active', nextState);
      $trigger.attr('aria-expanded', nextState);
      
      // Edge-case fix: If it's now visible, ensure it respects the CSS grid layout
      if (nextState) {
        $gridPanel.css('display', 'grid');
      }
    });
  });
});



$(document).ready(function() {
    function syncElementHeight() {
        var sourceElement = $('.GSC-BAR-xJcpbSxXGHTy');
        var targetElement = $('#shopify-section-sections--30185879765335__header'); 

        if (sourceElement.length && targetElement.length) {
            var currentHeight = sourceElement.outerHeight();
            targetElement.css('top', currentHeight + 'px');
        }
    }

    $(window).on('load', function() {
        syncElementHeight();
    });

    $(window).on('resize', function() {
        syncElementHeight();
    });

    var targetNode = document.querySelector('.GSC-BAR-xJcpbSxXGHTy');
    if (targetNode) {
        var observer = new MutationObserver(function(mutations) {
            syncElementHeight();
        });
        observer.observe(targetNode, { attributes: true, childList: true, characterData: true, subtree: true });
    }
// image for mobile



});


jQuery(document).ready(function($) {

  // Bind events (assuming updateChartAnimation is defined elsewhere)
  if (typeof updateChartAnimation === 'function') {
    $(window).on('scroll resize', updateChartAnimation);
    setTimeout(updateChartAnimation, 100);
  }

  /* ---- Responsive Image Optimizer ---- */
  function updateResponsiveImages() {
    // 767px is the standard breakpoint to catch all mobile device widths
    const isMobile = window.matchMedia('(max-width: 767px)').matches; 
    
    $('img[data-src-desktop][data-src-mobile]').each(function() {
      const $img = $(this);
      
      // Use .attr() instead of .data() to pull the exact string from the HTML
      const newSrc = isMobile ? $img.attr('data-src-mobile') : $img.attr('data-src-desktop');
      
      if (newSrc) {
        const currentSrc = $img.attr('src') || '';
        
        // Extract just the filename (e.g. "image.png") to avoid "https://" mismatch issues
        const newSrcFilename = newSrc.split('?')[0].split('/').pop(); 
        
        // If the current src doesn't contain the correct filename, swap it out
        if (!currentSrc.includes(newSrcFilename)) {
          $img.attr('src', newSrc);
        }
      }
    });
  }

  // Run on page load
  updateResponsiveImages();

  // Run on resize with a slight delay (debounce) for performance
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateResponsiveImages, 150);
  });

});


// forcefully insert text 
 window.addEventListener('DOMContentLoaded', () => {
    
      const heading = document.querySelector('.product-info__liquid h2');
      if (heading) {
        heading.textContent = 'Over 100.000 gebruikers en dit is waarom';
      }
   
  });